module.exports = __webpack_public_path__ + "img/27_92.6117b25b.png";